import { normalizeAssignedCategoryPath } from '@libs/algolia';

/** Product-index attribute used for direct CommerceTools category path assignments. */
export const ASSIGNED_CATEGORY_PATHS_ATTRIBUTE = 'assigned_category_paths';

/** Legacy product-index attribute with hierarchical category combinations. */
export const CUSTOM_CATEGORY_NAMES_ATTRIBUTE = 'custom_category_names';

export const getCategoryFilterAttribute = (isSubcatFilteringEnabled: boolean): string =>
    isSubcatFilteringEnabled ? ASSIGNED_CATEGORY_PATHS_ATTRIBUTE : CUSTOM_CATEGORY_NAMES_ATTRIBUTE;

/** Case-insensitive key for matching paths across category and product indices. */
export const normalizeCategoryPathForComparison = (path: string): string =>
    normalizeAssignedCategoryPath(path.toLowerCase());

/**
 * Maps a category display path to its normalized product-index filter value.
 */
export const resolveCategoryPathForFilter = (path: string, displayPathCatalog: string[] = []): string => {
    const comparisonKey = normalizeCategoryPathForComparison(path);
    const displayMatch = displayPathCatalog.find(
        candidate => normalizeCategoryPathForComparison(candidate) === comparisonKey
    );
    const resolvedPath = displayMatch ?? path;

    return normalizeAssignedCategoryPath(resolvedPath);
};

export const resolveCategoryPathsForFilter = (paths: string[], displayPathCatalog: string[] = []): string[] => [
    ...new Set(paths.map(path => resolveCategoryPathForFilter(path, displayPathCatalog))),
];

export const formatCategoryPathFilter = (paths: string[], attribute: string): string =>
    paths.map(path => `${attribute}:"${path}"`).join(' OR ');

export const buildCategoryPathFilter = (
    paths: string[],
    attribute: string,
    displayPathCatalog: string[] = []
): string => formatCategoryPathFilter(resolveCategoryPathsForFilter(paths, displayPathCatalog), attribute);

export const wrapOrFilterGroup = (filter: string): string => (filter.includes(' OR ') ? `(${filter})` : filter);

/** Splits alternate display paths joined with ` || ` into individual category paths. */
export const expandAlternateCategoryPaths = (paths: string[]): string[] =>
    paths.flatMap(path =>
        path
            .split(' || ')
            .map(part => part.trim())
            .filter(Boolean)
    );
